export default {"src":"/_next/static/media/kitapcik.a7a3132a.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};